<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="relative">
        <v-card elevation="0" height="92vh" class="card-main">
          <v-card-text>
            <v-row>
              <v-col cols="1">
                <v-card elevation="0" height="15vh" @click="goToAllCheckLists()" class="see-all-reports-card">
                  <v-card-text>
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-icon class="mt-3">mdi-text-box mdi-18px</v-icon>
                      <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                      <v-spacer></v-spacer>
                      <span class="mt-3">مشاهده</span>
                      <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                      <v-spacer></v-spacer>
                      <span>همه گزارشات</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="11">
                <v-row>
                  <v-col cols="4">
                    <v-card height="15vh" class="data-card1" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-phone mdi-flip-h mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5" class="mr-3">
                            <h2 class="data-card-title">گزارشات ثبت شده</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="2">
                            <h2 class="data-card-content">
                              {{ totalReports }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card height="15vh" class="data-card2" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5" class="">
                            <h2 class="data-card-title pr-2">آمبولانس ها / موتورلانس ها</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="5" class="text-left">
                            <h2 class="data-card-content">
                              {{ ambulanceReports }} /
                              {{ motorAmbulanceReports }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card height="15vh" class="data-card3" elevation="0">
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="darkColor" class="data-card-icon">
                              mdi-clock-time-four mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="5">
                            <h2 class="data-card-title pr-2">کدهای فعال/ کدهای رزرو</h2>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="5" class="text-left">
                            <h2 class="data-card-content">
                              {{ activeCodes }} / {{ reserveCodes }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card height="15vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-img :src="dashboardIMG" contain class="second-row-img"></v-img>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col class="mt-1 row-2-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ fuelEmpty }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">سوخت خالی</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="mt-1 row-2-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ fuelQuarter }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">سوخت 1/4</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="mt-1 row-2-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ fuelHalf }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">سوخت 1/2</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="mt-1 row-2-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ threeQuarter }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">سوخت 3/4</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="mt-1 row-2-space">
                        <v-row>
                          <v-col cols="1"></v-col>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </v-col>
                          <v-col cols="7">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ fuelFull }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">سوخت کامل</h2>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-card height="calc(61vh - 80px)" elevation="1" class="detail-115-dashboard-card">
                  <v-card-title>
                    <v-row>
                      <v-col cols="3">
                        <span>کسورات دارویی</span>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="6">
                        <v-text-field placeholder="جستجو..." append-icon="mdi-magnify mdi-18px" dense rounded
                          v-model="searchDrug" outlined></v-text-field>
                      </v-col>

                      <v-col cols="2">
                        <v-btn fab dark small color="darkColor" elevation="0" @click="openDrugShortagesFilterModal">
                          <v-icon dark>mdi-filter mdi-18px</v-icon>
                        </v-btn>

                        <v-tooltip v-if="hasAnyDrugShortageFilter" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon light v-bind="attrs" v-on="on" @click="removeDrugShortageFilter()" class="mr-4">
                              mdi-filter-remove mdi-18px
                            </v-icon>
                          </template>
                          <span>حذف فیلتر ها</span>
                        </v-tooltip>
                      </v-col>
                      <!-- <v-col cols="2" v-if="hasAnyDrugShortageFilter">
                        
                      </v-col> -->
                      <v-spacer></v-spacer>
                      <v-col cols="1">
                        <v-btn @click="
                          exportToExcel(
                            drugShortageCountTableHeader,
                            drugShortageCountTableItems,
                            'text',
                            `drug_shortage_report`,
                          )
                          " fab dark small color="darkColor" elevation="0">
                          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
                        </v-btn>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mt-n10">
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <v-data-table hide-default-header :headers="drugShortageCountTableHeader"
                            :items="drugShortageCountTableItems" :items-per-page="drugShortageCountTableItems.length"
                            height="40vh" :hide-default-footer="true" :search="searchDrug" multi-sort
                            class="elevation-0">
                            <template v-slot:header="props">
                              <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                                @group="props.on.group" />
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                    @click="goToAllCheckListsFromDrug(item.id)" v-bind="attrs" v-on="on">
                                    mdi-text-box
                                  </v-icon>
                                </template>
                                <span>جزئیات</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:no-data>
                              <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                            </template>
                          </v-data-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card height="calc(61vh - 80px)" elevation="1" class="detail-115-dashboard-card">
                  <v-card-title>
                    <v-row>
                      <v-col cols="4">
                        <span>آیتم های انتخاب نشده</span>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="6">
                        <v-text-field placeholder="جستجو..." append-icon="mdi-magnify mdi-18px" dense rounded
                          v-model="searchNotSelected" outlined></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="1">
                        <v-btn @click="
                          exportToExcel(
                            notSelectedItemsCountTableHeader,
                            notSelectedItemsCountTableItems,
                            'text',
                            `not_selected_items_report`,
                          )
                          " fab dark small color="darkColor" elevation="0">
                          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
                        </v-btn>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mt-n10">
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <v-data-table :headers="notSelectedItemsCountTableHeader"
                            :items="notSelectedItemsCountTableItems"
                            :items-per-page="notSelectedItemsCountTableItems.length" height="40vh"
                            :hide-default-footer="true" multi-sort :search="searchNotSelected" class="elevation-0">
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                    @click="goToAllCheckListsFromNotSelectd(item.id)" v-bind="attrs" v-on="on">
                                    mdi-text-box
                                  </v-icon>
                                </template>
                                <span>جزئیات</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:no-data>
                              <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                            </template>
                          </v-data-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <drug-shortage-filter-modal :is-filter-modal-open="isDrugShortageFilterModalOpen"
      :from-date="drugShortageFilterFields.fromDate" :to-date="drugShortageFilterFields.toDate"
      @close-filter-modal="closeDrugShortagesFilterModal" @search="searchDrugShortage" />
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';
import DrugShortageFilterModal from '@/components/Qc/CheckList/modal/drugShortage.filter.vue';
import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import QcCheckListReportHelper from '@/Helpers/QC/QcCheckListReportHelper.js';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin';
import checkListMixin from '@/Mixins/BaseInformation/CheckListMixin.js';
export default {
  name: 'QCCheckListDashboard',
  title: 'داشبورد تحویل و تحول',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    AppGroupTableHeader,
    DrugShortageFilterModal,
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    QcCheckListReportHelper,
    DashboardMixin,
    checkListMixin,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.QCCheckListDashboard = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      // this.initialFilter();
      this.getQCCheckListDashboardFunction(null, null, null);
      this.getDrugShortageCountFunction();
      this.getNotSelectedItemsCountFunction();
    },
  },
  computed: {},
};
</script>
<style scoped>
.card-main {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  margin-top: 1vh;
  margin-right: 1.5vh;
}

.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.see-all-reports-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  cursor: pointer;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}

>>>.second-row-img {
  position: absolute;
  margin-top: 1.5%;
}

.row-2-space {
  width: 20% !important;
  min-width: 20% !important;
  max-width: 20% !important;
}

>>>table {
  background: var(--background-color) !important;
}

.filter-container {
  position: absolute;
  top: 1rem;
  right: 8rem;
  z-index: 2;
  background-color: white;
}

.filter-container>.col {
  cursor: pointer;
}
</style>
